// src/app/config.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  // Define your API base URL here


  constructor() {}
getApiUrl(): string {
   
return 'https://coophpapi.atishay.com/api';
     
  } 
  getFileUrl(): string {
   
     return 'https://coophpapi.atishay.com/UploadedFiles/';
     
  }
   getprofileUrl(): string {
     return 'https://coophpapi.atishay.com/UploadedFiles/Profile_Images/';
 
  } 

}
